import React from 'react'
import { STATES_WHITELIST } from '../../utils/getStatesWhiteList'
import { TAXONOMIES_WHITELIST } from '../../utils/getTaxonomiesWhiteList'
import { getLocations } from '../../domain/center'
import { getSlug } from '../../domain/location.ts'
import { UNITED_STATES } from '../../domain/location/constants'

const containerCss =
  'w-screen mb-[-30px] bg-stone-100 overflow-hidden flex flex-col mt-[32px] px-[25px] py-[30px] [@media(min-width:450px)]:px-0 [@media(min-width:450px)]:py-[48px] relative z-100'
const innerContainerCss =
  'flex flex-col [@media(min-width:962px)]:flex-row items-start gap-0 [@media(min-width:962px)]:gap-[40px] items-stretch bg-stone-100 m-auto py-[20px]'
const columnCss = 'flex-1 p-[20px] bg-stone-100 word-break'
const columnHeadingCss =
  'text-gray-1100 text-[20px] font-Figtree font-semibold leading-8 mb-[10px] flex flex-col justify-center flex-1 flex-shrink-0 whitespace-nowrap'
const ulCss = 'p-[0px] list-none mb-[5px]'
const liCss = 'text-gray-1100 text-[16px] font-Figtree leading-[24px] mb-[5px]'
const aCss = 'hover:underline'

const RelatedLinks = ({ data }) => {
  let locationTitles = data.locations

  const whiteListedSpecializations = data._new_specializations.filter(
    (item) =>
      TAXONOMIES_WHITELIST.includes(item?.title) &&
      !item.type.includes('special_consideration') &&
      !item.type.includes('specialization')
  )

  const matchingStateOrNull = data._locations.filter((item) =>
    STATES_WHITELIST.includes(item?.title)
  )

  let primaryCities = data._locations.filter((location) =>
    location?.geo?.types?.includes('locality')
  )

  const centerLocations = getLocations(data)
  const filteredCenterLocations = centerLocations.filter(
    (loc) => loc.slug !== 'north-america'
  )

  const currentCenterLocationSlug = getSlug(
    filteredCenterLocations.length > 0
      ? filteredCenterLocations[filteredCenterLocations.length - 1]
      : centerLocations[centerLocations.length - 1]
  )

  let primaryCity = primaryCities ? primaryCities[0] : null
  let relatedLocations = primaryCity?._related_locations
    ?.filter(Boolean)
    .filter((location) => {
      return (
        !location?.title?.includes('India') &&
        !location?.title?.includes('United States') &&
        !location?.title?.includes('North America') &&
        !location?.title?.includes('Canada') &&
        !location?.title?.includes('Australia') &&
        !location?.title?.includes('South America') &&
        !location?.title?.includes('Mexico') &&
        !location?.title?.includes('Central America') &&
        !location?.title?.includes('Latin America') &&
        !location?.title?.includes('Caribbean') &&
        !location?.title?.includes('Africa') &&
        !location?.title?.includes('Asia') &&
        !location?.title?.includes('Europe')
      )
    })

  return (
    <div className={containerCss}>
      <div className={innerContainerCss}>
        <div className={`w-[324px] ${columnCss}`}>
          <h4 className="font-Figtree mb-[10px] flex whitespace-nowrap text-center text-[30px] font-medium leading-[36px] text-gray-1100">
            Explore More
          </h4>
          <div className="font-Figtree flex flex-col items-stretch justify-center text-[18px] leading-8 text-gray-800">
            Easily search by condition, location, and other programs tailored to
            meet your needs.
          </div>
        </div>

        {whiteListedSpecializations.length > 0 && (
          <div className={columnCss}>
            <h4 className={columnHeadingCss}>Specializations</h4>
            <ul className={ulCss}>
              {whiteListedSpecializations.slice(0, 5).map((specialization) => {
                return (
                  <li
                    className={liCss}
                    key={specialization.slug}
                  >
                    {locationTitles.includes(UNITED_STATES) &&
                      matchingStateOrNull.length > 0 && (
                        <a
                          className={aCss}
                          href={`/${getSlug(matchingStateOrNull[0])}/${
                            specialization.slug
                          }/`}
                        >
                          {specialization.title} Rehabs
                        </a>
                      )}
                    {locationTitles.includes('Asia') &&
                      !locationTitles.includes('India') && (
                        <a
                          className={aCss}
                          href={`/asia/${specialization.slug}/`}
                        >
                          {specialization.title} Rehabs
                        </a>
                      )}
                    {locationTitles.includes('South America') && (
                      <a
                        className={aCss}
                        href={`/south-america/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                    {locationTitles.includes('Central America') && (
                      <a
                        className={aCss}
                        href={`/central-america/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                    {locationTitles.includes('Mexico') && (
                      <a
                        className={aCss}
                        href={`/mexico/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                    {locationTitles.includes('Latin America') &&
                      !locationTitles.includes('Mexico') && (
                        <a
                          className={aCss}
                          href={`/latin-america/${specialization.slug}/`}
                        >
                          {specialization.title} Rehabs
                        </a>
                      )}
                    {locationTitles.includes('Africa') && (
                      <a
                        className={aCss}
                        href={`/africa/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                    {locationTitles.includes('Canada') && (
                      <a
                        className={aCss}
                        href={`/canada/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                    {locationTitles.includes('Europe') && (
                      <a
                        className={aCss}
                        href={`/europe/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                    {locationTitles.includes('Australia') && (
                      <a
                        className={aCss}
                        href={`/australia/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                    {locationTitles.includes('India') && (
                      <a
                        className={aCss}
                        href={`/india/${specialization.slug}/`}
                      >
                        {specialization.title} Rehabs
                      </a>
                    )}
                  </li>
                )
              })}
            </ul>
          </div>
        )}

        {relatedLocations && (
          <div className={columnCss}>
            <h4 className={columnHeadingCss}>Destinations</h4>
            <ul className={ulCss}>
              {relatedLocations.slice(0, 5).map((loc) => (
                <li
                  className={liCss}
                  key={loc.slug}
                >
                  <a
                    className={aCss}
                    href={`/${loc.slug}/`}
                  >
                    {loc.title} Rehabs
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={columnCss}>
          <h4 className={columnHeadingCss}>Popular Searches</h4>
          <ul className={ulCss}>
            <li className={liCss}>
              <a
                className={aCss}
                href={
                  locationTitles.includes(UNITED_STATES)
                    ? '/price/insurance-accepted/'
                    : `/${currentCenterLocationSlug}/`
                }
              >
                {locationTitles.includes(UNITED_STATES)
                  ? 'Accepts Insurance'
                  : 'Drug and Alcohol Rehabs'}
              </a>
            </li>

            <li className={liCss}>
              <a
                className={aCss}
                href={
                  locationTitles.includes(UNITED_STATES)
                    ? `/amenities/allow-cell-phones/`
                    : `/${currentCenterLocationSlug}/depression/`
                }
              >
                {locationTitles.includes(UNITED_STATES)
                  ? 'Allow Cell Phones'
                  : 'Mental Health Treatment Centers'}
              </a>
            </li>

            <li className={liCss}>
              <a
                className={aCss}
                href={
                  locationTitles.includes(UNITED_STATES)
                    ? `/clientele/adolescents/`
                    : `/luxury/`
                }
              >
                {locationTitles.includes(UNITED_STATES)
                  ? 'Teen Rehabs'
                  : 'Luxury Rehabs'}
              </a>
            </li>

            <li className={liCss}>
              <a
                className={aCss}
                href={
                  locationTitles.includes(UNITED_STATES)
                    ? '/amenities/pet-friendly/'
                    : '/clientele/executives/'
                }
              >
                {locationTitles.includes(UNITED_STATES)
                  ? 'Pet-Friendly Rehabs'
                  : 'Executive Rehabs'}
              </a>
            </li>

            <li className={liCss}>
              <a
                className={aCss}
                href={
                  locationTitles.includes(UNITED_STATES) ? '' : '/care/retreat/'
                }
              >
                {locationTitles.includes(UNITED_STATES)
                  ? ''
                  : 'Retreat Programs'}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default RelatedLinks
